export type PaginatedRequestOptions = {
  limit?: number;
  offset?: number;
  baseURL?: string;
  /**
   * Complete URL to be used in place of the default URL constructed by the
   * endpoint path, and `baseURL`, `limit`, and `offset` options. This option
   * should only be used when fetching paginated results with the next/previous
   * properties in the response.
   * */
  url?: string;
};

export function getPaginatedRequestURL(
  path: string,
  options: PaginatedRequestOptions = {},
) {
  if (options.url) {
    return options.url;
  }

  const params = new URLSearchParams();

  if (options.limit) {
    params.append('limit', String(options.limit));
  }

  if (options.offset) {
    params.append('limit', String(options.offset));
  }

  const queryString = params.toString();

  return (
    (options.baseURL ?? '') + path + (queryString ? `?${queryString}` : '')
  );
}
